<!--评论模块-->
<template>
  <div class="containers">
    <transition name="fade">
      <div class="input-wrapper" >
        <el-input class="gray-bg-input"
                  v-model="comment.content"
                  type="textarea"
                  :rows="3"
                  placeholder="写下你的评论">
        </el-input>
        <div class="btn-control">
<!--          <span class="cancel" @click="cancel">取消</span>-->
          <el-button class="btn" type="success" round @click="commitComment">发表</el-button>
        </div>
      </div>
    </transition>

    <div class="comment" v-for="item in comments">
      <div class="info">
        <img class="avatar" :src="item.fromAvatar" width="50" height="50"/>
        <div class="right">
          <div class="name">{{item.fromName}}</div>
          <div class="date">{{item.data}}</div>

          <div class="content">{{item.content}}</div>
          <div class="control">
            <span class="like" :class="{active: item.isLike}" @click="likeClick(item)">
              <i class="iconfont icon-like"></i>
<!--              <span class="like-num iconfont">&#xec8c;{{item.likeNum > 0 ? item.likeNum + '人赞' : '赞'}}</span>-->
              <span class="like-num iconfont">&#xec8c;&nbsp;{{item.likeNum }}</span>
            </span>
            <span class="comment-reply" @click="showCommentInput(item)">
              <i class="iconfont icon-comment"></i>
              <span>回复</span>
            </span>
          </div>
        </div>
      </div>
      <div class="reply">
        <div class="item" v-for="reply in item.reply">
          <img class="avatar" :src="reply.fromAvatar" width="30" height="30"/>
<!--          <img class="avatar" :src="@/src/assets/img/avatar/avator.jpg" width="30" height="30"/>-->
          <div class="right">
            <div class="reply-content">
              <span class="from-name">{{reply.fromName}}</span><span>: </span>
              <span class="to-name">@{{reply.toName}}</span>
              <span>{{reply.content}}</span>
            </div>
            <div class="reply-bottom">
              <span>{{reply.data}}</span>
              <span class="reply-text" @click="showCommentInput(item, reply)">
              <i class="iconfont icon-comment"></i>
              <span>回复</span>
            </span>
            </div>
          </div>

        </div>
        <div class="write-reply" v-if="item.reply.length > 0" @click="showCommentInput(item)">
          <i class="el-icon-edit"></i>
          <span class="add-comment">添加新评论</span>
        </div>
        <transition name="fade">
          <div class="input-wrapper" v-if="showItemId === item.id">
            <el-input class="gray-bg-input"
                      v-model="inputComment"
                      type="textarea"
                      :rows="3"
                      autofocus
                      placeholder="写下你的评论">
            </el-input>
            <div class="btn-control">
              <span class="cancel" @click="cancel">取消</span>
              <el-button class="btn" type="success" round @click="commitReply">发表</el-button>
            </div>
          </div>
        </transition>
      </div>

    </div>
  </div>
</template>

<script>
  import { commitComment,getComments ,commitReply,addCommentLike} from '@/api/videoDetail'
  export default {
    props: ['id','order'],
    components: {},
    data() {
      return {
        comments:[],
        inputComment: '',
        showItemId: '',
        replyFlag:'',
        comment:{
          content:'',
          ownerId:''
        },
        reply:{
          content:'',
          toId:'',
          commentId:''
        }
      }
    },
    created(){
      this.getComments()
    },

    methods: {
      /**
       * 获取数据
      */
       getComments(){
        getComments(this.id,this.order).then(res => {
          if (res.code === 20000) {
            this.comments = res.data
          }
        })
      },

       /*
       * 点赞
       */
      likeClick(item) {

        if (item.isLike === null) {
          debugger
          addCommentLike(item.id).then(res=>{
            if(res.code===20000){
              Vue.$set(item, "isLike", true);
              item.likeNum++
            }

          })

        } else {
          if (item.isLike) {
            // item.likeNum--
          } else {
            addCommentLike(item.id).then(res=>{
            item.likeNum++
            })
            item.isLike = !item.isLike;
          }

        }
      },

      /**
       * 点击取消按钮
       */
      cancel() {
        this.showItemId = ''
      },

      /**
       * 提交评论
       */
      commitComment() {
        this.comment.ownerId=this.id
        if (this.comment.content==='' ) {
          this.$message({
            message: '消息不能为空',
            type: 'warning'
          });
          return
        }
        commitComment(this.comment).then(res=>{
          if(res.code===20000 && res.data===1){
            this.$message({
              message: res.message,
              type: 'success',
              duration: 5 * 1000
            });
          }
          this.getComments()
        })
      },

      commitReply(){
        if(this.replyFlag==='1'){

          this.reply.content=this.inputComment.substr(this.inputComment.indexOf(' ')+1)
        }else {
          this.reply.content=this.inputComment
        }
        if (this.reply.content==='' ) {
          this.$message({
            message: '消息不能为空',
            type: 'warning'
          });
          return
        }
        // this.reply.toId=this.showItemId
        commitReply(this.reply).then(res=>{
          if(res.code===20000 && res.data===1){
            this.$message({
              message: res.message,
              type: 'success'
            });
            this.inputComment = ''
          }
          this.getComments()

        })
      },

      /**
       * 点击评论按钮显示输入框
       * item: 当前大评论
       * reply: 当前回复的评论
       */
      showCommentInput(item, reply) {
        if (reply) {
          this.inputComment = "@" + reply.fromName + " "
          this.replyFlag='1'
          this.reply.commentId=reply.commentId
        } else {
          this.replyFlag=''
          this.inputComment = ''
          this.reply.commentId = item.id

        }
        this.showItemId = item.id
        this.reply.toId = item.fromId

      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../../assets/icon/iconvideo/iconfont.css";
  @import "../../assets/icon/iconfont.css";
  @import "../../assets/scss/comments";

  .containers {
    padding: 0 10px;
    box-sizing: border-box;
    .comment {
      display: flex;
      flex-direction: column;
      /*padding: 10px;*/
      border-bottom: 1px solid $border-fourth;
      .info {
        display: flex;
        align-items: center;
        .avatar {
          border-radius: 50%;
        }
        .right {
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          .name {
            font-size: 16px;
            color: $text-main;
            margin-bottom: 5px;
            font-weight: 500;
          }
          .date {
            font-size: 12px;
            color: $text-minor;
          }
        }
      }
      .content {
        font-weight: 500;
        font-size: 14px;
        color: $text-main;
        line-height: 20px;
        padding: 10px 0;
      }
      .control {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: $text-minor;
        .like {
          display: flex;
          align-items: center;
          margin-right: 20px;
          cursor: pointer;
          &.active, &:hover {
            color: $color-main;
          }
          .iconfont {
            font-size: 14px;
            margin-right: 5px;
          }
        }
        .comment-reply {
          display: flex;
          align-items: center;
          cursor: pointer;
          &:hover {
            color: $text-333;
          }
          .iconfont {
            font-size: 16px;
            margin-right: 5px;
          }
        }

      }
      .reply {
        margin: 10px 0;
        border-left: 2px solid $border-first;
        margin-left: 50px;
        .item {
          display: flex;
          align-items: center;
          margin: 0 10px;
          padding: 10px 0;
          border-bottom: 1px dashed $border-third;
          .right{
            flex-direction: column;
            margin-left: 10px;
            .reply-content {
              display: flex;
              align-items: center;
              font-size: 12px;
              font-weight: 500;
              color: $text-main;
              .from-name {
                color: $color-main;
              }
              .to-name {
                color: $color-main;
                margin-left: 5px;
                margin-right: 5px;
              }
            }
            .reply-bottom {
              display: flex;
              align-items: center;
              margin-top: 6px;
              font-size: 12px;
              color: $text-minor;
              .reply-text {
                display: flex;
                align-items: center;
                margin-left: 10px;
                cursor: pointer;
                &:hover {
                  color: $text-333;
                }
                .icon-comment {
                  margin-right: 5px;
                }
              }
            }
          }



        }
        .write-reply {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: $text-minor;
          padding: 10px;
          cursor: pointer;
          &:hover {
            color: $text-main;
          }
          .el-icon-edit {
            margin-right: 5px;
          }
        }
        .fade-enter-active, fade-leave-active {
          transition: opacity 0.5s;
        }
        .fade-enter, .fade-leave-to {
          opacity: 0;
        }
        .input-wrapper {
          padding: 10px;
          .gray-bg-input, .el-input__inner {
            /*background-color: #67C23A;*/
          }
          .btn-control {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-top: 10px;
            .cancel {
              font-size: 16px;
              color: $text-normal;
              margin-right: 20px;
              cursor: pointer;
              &:hover {
                color: $text-333;
              }
            }
            .confirm {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
  .btn-control{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-top: 10px;
  }
  .avatar {
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/comments/index.vue